export default path => path.replace('../../static/uploads', '/uploads')
